import React from "react";
import { Layout } from '@abyss/web/ui/Layout';
import { Divider } from '@abyss/web/ui/Divider';
import { Label } from '@abyss/web/ui/Label';
import { styled } from '@abyss/web/tools/styled';

const StyledLabel = styled(Label, {
    fontSize: '9px!important',
    fontWeight: '200!important'
});

export const FooterCopyRights = () => {
    return (
        <Layout.Group>
            <StyledLabel size="$xs" color="$primary2">&copy; { new Date().getFullYear() } Optum</StyledLabel>
            <Divider orientation="vertical" height={10} width={1} />
            <StyledLabel size="$xs" color="$primary2">All Rights Reserved</StyledLabel>
        </Layout.Group>
    )
}